<template>
<div class="chapter">
<div class="inner_page">
<h1>Little Cowpokes Cookbook</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<span href="#/ch01" title="Link target outside of Sample">Yeehaw! A Recipe Roundup </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch02" title="Link target outside of Sample">Breakfast at the Ranch </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e110" title="Link target outside of Sample">Brown Sugar Mule Muffins </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e149" title="Link target outside of Sample">Eggs Rancheros </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e191" title="Link target outside of Sample">Buttermilk Flappin’ Flapjacks with
                                    Blueberry Sauce </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e245" title="Link target outside of Sample">Fruit Pony Tails </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch02#d0e273" title="Link target outside of Sample">Cowboy Kettle Cocoa </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Cowpunchers Campout </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e320" title="Link target outside of Sample">Range BBQ Chicken </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e359" title="Link target outside of Sample">Cactus Kabobs </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e389" title="Link target outside of Sample">Saddle Up S’mores </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e415" title="Link target outside of Sample">Johnny Cakes </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch03#d0e465" title="Link target outside of Sample">Fire-Roasted Cob Corn with Herb Butter
                                </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">Rodeo Refreshments </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e519" title="Link target outside of Sample">Buckin’ Bull Nachos with Avocado Salsa
                                </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e565" title="Link target outside of Sample">Get Along Pretzel Doggies </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e609" title="Link target outside of Sample">Cinnamon Churro Sundaes </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e642" title="Link target outside of Sample">Whippersnapper Slush </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch04#d0e668" title="Link target outside of Sample">Jamboree Krispy Pops </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">Chuck Wagon Dinner </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e722" title="Link target outside of Sample">Cooky’s Cole Slaw </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e756" title="Link target outside of Sample">Trail Ride Beans </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e790" title="Link target outside of Sample">Slow-Cooked Smoky Brisket </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e820" title="Link target outside of Sample">Cheddar and Honey Hot Rocks </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch05#d0e850" title="Link target outside of Sample">Fresh-Squeezed Lemonade </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">The Pioneer’s Pantry </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e886" title="Link target outside of Sample">Orchard Medley Salad </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e913" title="Link target outside of Sample">Potatoes ’n’ Coats </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e958" title="Link target outside of Sample">Oven-Roasted Turkey with Kitchen Garden
                                    Vegetables </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e995" title="Link target outside of Sample">Apple Tarts </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch06#d0e1041" title="Link target outside of Sample">Pioneer Honey Taffy </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">Wild Western Grub </span>
</span>
</dt>
<dd>
<dl>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e1084" title="Link target outside of Sample">Train Robbery Gold </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e1118" title="Link target outside of Sample">Boot Hill Pudding Cups </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e1146" title="Link target outside of Sample">Texas Sheet Cake </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e1209" title="Link target outside of Sample">Sheriff’s Sugar Cookies </span>
</span>
</dt>
<dt>
<span class="bridgehead">
<span href="#/ch07#d0e1261" title="Link target outside of Sample">Wild West Gingerbread House </span>
</span>
</dt>
</dl>
</dd>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">Metric Conversion Chart</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?02a57886